import type { ReportSearch } from './api'

export function reportSearchFrom(search: Record<string, unknown>): ReportSearch {
  const parseIds = (value: unknown): string[] | undefined => {
    const ids = Array.isArray(value)
      ? value.filter((id): id is string => typeof id === 'string' && id !== '')
      : typeof value === 'string' && value !== ''
        ? [value]
        : []
    return ids.length ? ids : undefined
  }
  return {
    from: typeof search.from === 'string' && search.from !== '' ? search.from : undefined,
    to: typeof search.to === 'string' && search.to !== '' ? search.to : undefined,
    as_at: typeof search.as_at === 'string' && search.as_at !== '' ? search.as_at : undefined,
    cost_center_id:
      typeof search.cost_center_id === 'string' && search.cost_center_id !== ''
        ? search.cost_center_id
        : undefined,
    cost_center_ids: parseIds(search.cost_center_ids),
    analysis_tag_ids: parseIds(search.analysis_tag_ids),
    journal_ids: parseIds(search.journal_ids),
    group_by:
      search.group_by === 'cost_center' || search.group_by === 'analysis_tag'
        ? search.group_by
        : undefined,
    compare_prior: search.compare_prior === '1' || search.compare_prior === true ? true : undefined,
    side: search.side === 'receivable' || search.side === 'payable' ? search.side : undefined,
    age_by:
      search.age_by === 'due_date' || search.age_by === 'document_date' ? search.age_by : undefined,
  }
}
